<style lang="less" rel="stylesheet/less" scoped>
    .question-select{
        ._body{
            background:rgba(255,255,255,1);
            border-radius:5px;
            overflow:hidden;
            box-shadow:0px 2px 10px 2px rgba(51,51,51,0.1);
            ._header{
                background:rgba(248,249,250,1);
                font-size:16px;
                color:#1D7DEF;
                padding:15px 30px;
            }
            .option-list{
                display:flex;
                justify-content:space-around;
                padding:15px 10px;
                .option-item{
                    font-size:16px;
                    color:#333;
                    line-height:40px;
                    .label{
                        font-weight:bold;
                    }
                }
                &.type-2{
                    flex-direction:column;
                    padding:30px 0;
                    .option-item{
                        padding-left:90px;
                    }
                }
            }
        }
        ._bottom{
            margin-top:30px;
        }
        .button-list{
            text-align:center;
            .button-item{
                display:inline-block;
                width:50px;
                height:50px;
                background:rgba(255,255,255,1);
                border:4px solid #fff;
                border-radius:18px;
                line-height:50px;
                color:#333;
                font-size:24px;
                font-weight:bold;
                margin:0 5px 5px 5px;

                &.active{
                    border-color:rgba(0,227,128,1);
                }
            }
        }
    }
</style>
<template>
    <div class="question-select">
        <div class="_body">
            <div class="_header">
                {{item.title}}
            </div>
            <div :class="`option-list ${item.option_list.length > 2 ? 'type-2' : 'type-1'}`">
                <div class="option-item" v-for="option in item.option_list"><span class="label">{{option.option}}</span> {{option.desc}}</div>
            </div>
        </div>
        <div class="_bottom">
            <div class="button-list">
                <div class="button-item" :class="{active:isSelected(option.id)}" @click="buttonClick(option)" v-for="option in item.option_list">{{option.option}}</div>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    import {QUESTION_TYPE} from '../lib/const';
    import event from '../lib/event';

    export default {
        props:['item'],
        data() {
            return {}
        },
        computed: {},
        methods: {
            isSelected(n){
                return this.item.answer.split('|').indexOf(n.toString())>-1;
            },
            addAnswer(n){
                if(!this.isSelected(n)){
                    let arr = this.item.answer.split('|').filter(a=>!!a);
                    arr.push(n);
                    this.item.answer = arr.join('|');
                }
            },
            removeAnswer(n){
                if(this.isSelected(n)){
                    let arr = this.item.answer.split('|');
                    let idx = arr.indexOf(n.toString());
                    arr.splice(idx,1);
                    this.item.answer = arr.join('|');
                }
            },
            isMulti(){
                return this.item.type === QUESTION_TYPE.MULTI_SELECT
            },
            buttonClick(option){
                let id = option.id;
                if(this.isMulti()){
                    if(this.isSelected(id)){
                        this.removeAnswer(id);
                    }else{
                        this.addAnswer(id);
                    }
                }else{
                    this.item.answer = "";
                    this.addAnswer(id);
                }
            },
            isRequired(){
                return this.item.required !== false;
            },
            checkValid(){
                if(this.isRequired() && !this.item.answer.trim()){
                    event.emit('toast',this.item.warn_text||'此项必填');
                    return false;
                }
                return true;
            }
        },
        components: {},
        mounted() {

        }
    }
</script>


// WEBPACK FOOTER //
// QuestionTypeSelect.vue?8f9b0a7e